import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { TabBarBone } from '../../molecules/TabBarBone/TabBarBone';
import { FormSectionBone } from '../../organisms/FormSectionBone/FormSectionBone';

interface FormSkeletonProps {
    /** Sections du formulaire */
    sections?: string[];
    /** Afficher les onglets */
    showTabs?: boolean;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const FormSkeleton: React.FunctionComponent<FormSkeletonProps> = function ({
    sections = ['header', 'folio', 'publisher', 'products', 'totals'],
    showTabs = true,
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100vh',
                ...sx,
            }}
        >
            {showTabs && <TabBarBone tabsCount={3} />}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    flex: 1,
                    padding: 2,
                }}
            >
                {sections.map((sectionName) => (
                    <FormSectionBone
                        sx={{ height: '130px' }}
                        key={`form-section-${sectionName}`}
                        sectionName={sectionName}
                        totalSections={sections.length}
                    />
                ))}
            </Box>
        </Box>
    );
};
